/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dictation_ListeningInputs */

const en_dictation_listening = /** @type {(inputs: Dictation_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening…`)
};

const pt_br2_dictation_listening = /** @type {(inputs: Dictation_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvindo…`)
};

/**
* | output |
* | --- |
* | "Listening…" |
*
* @param {Dictation_ListeningInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dictation_listening = /** @type {((inputs?: Dictation_ListeningInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dictation_ListeningInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dictation_listening(inputs)
	return pt_br2_dictation_listening(inputs)
});